import React from "react";
import PropTypes from "prop-types";

const Checkbox = ({
  disabled,
  className = "",
  label = "", // AGREGAR CUANDO SOLO SE MOSTRARA TEXTO
  children,
  checked = false,
  value = "",
  id = null,
  tyc = true,
  htmlFor = true,
  onClick,
  hasError = null,
  clickedLabel = false,
  style = {},
  onClickLabel
}) => {
  const onClicked = () => {
    if (onClick && !disabled) {
      onClick(!checked);
    }
  };

  return (
    <>
      <div
        id={id}
        className={`rd--checkbox ${checked ? "is-checked" : ""} ${className} ${
          disabled ? "disabled" : ""
        }`.trim()}
        style={style}
      >
        <div className="rd--checkbox-box" onClick={onClicked}>
          <input
            type="checkbox"
            className="rd--checkbox-input"
            id={id}
            disabled={disabled}
            value={value}
            defaultChecked={checked}
          />
          <span className="rd--checkbox-checkmark"></span>
        </div>
        <label
          onClick={() => (clickedLabel ? onClickLabel() : {})}
          className={`rd--checkbox-label ${tyc ? "tyc" : ""}`.trim()}
          htmlFor={htmlFor ? id : null}
        >
          {label}
        </label>
      </div>
      {hasError && (
        <span className="rd--checkbox-error" htmlFor={id}>
          {hasError}
        </span>
      )}
    </>
  );
};

Checkbox.propTypes = {
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
